let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kTurq"), load("djb49"), load("fviv5"), load("d8WL7"), load("2RQvP"), load("7Lkvk")]).then(() => parcelRequire('coZ2w'));